import { configureStore } from '@reduxjs/toolkit';
import { createBrowserHistory } from 'history';
import { createReduxHistoryContext } from 'redux-first-history';
import { persistStore } from 'redux-persist';
import createSagaMiddleware from 'redux-saga';

import { config } from '@/config/config';
import { logger } from '@/config/logger';
import { env } from '@/env';
import { setStore } from '@/services/context';

import { createRootReducer } from './createRootReducer';
import { createRootSaga } from './createRootSaga';

export const createStore = () => {
    const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
        history: createBrowserHistory(),
    });

    const sagaMiddleware = createSagaMiddleware({
        onError: error => {
            logger.error(error);
        },
    });

    const middleware = [routerMiddleware, sagaMiddleware];

    const reducer = createRootReducer(routerReducer);

    const store = configureStore({
        devTools: config.dev.reduxDevTools,
        reducer,
        middleware,
    });

    setStore(store);

    if (env.VITE_PLAYWRIGHT_RUN) {
        window.store = store;
    }

    const saga = createRootSaga();

    sagaMiddleware.run(saga);

    const history = createReduxHistory(store);
    const persistor = persistStore(store);

    return { store, history, persistor };
};
